import { useState, useEffect } from "react";
import Campo from "./components/forms/Campo";

export default function LoginScreen({ onLogin }) {
  const [email,    setEmail   ] = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError   ] = useState("");
  const [loading,  setLoading ] = useState(false);
  const [mounted,  setMounted ] = useState(false);

  useEffect(() => { setTimeout(() => setMounted(true), 50); }, []);

  const handleSubmit = async () => {
    if (!email || !password) return setError("Completa todos los campos");
    setLoading(true); setError("");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:3001/api"}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user",  JSON.stringify(data.user));
        onLogin(data.user, data.token);
      } else {
        setError(data.error || "Credenciales incorrectas");
      }
    } catch {
      setError("Error de conexión con el servidor");
    }
    setLoading(false);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700;800&family=DM+Mono:wght@400;500&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'DM Sans', system-ui, sans-serif; }

        .login-root {
          min-height: 100vh;
          min-height: 100dvh;
          display: flex;
          background: #0B2849;
          font-family: 'DM Sans', system-ui, sans-serif;
          /* overflow-y auto y no hidden: con el movil tumbado (390px de alto)
             el formulario no cabia y quedaba recortado sin poder bajar. */
          overflow-x: hidden;
          overflow-y: auto;
          position: relative;
        }


        /* Glow blobs */
        .blob1 {
          position: absolute;
          width: 600px; height: 600px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(0,180,216,.12) 0%, transparent 70%);
          top: -200px; left: -200px;
          pointer-events: none;
        }
        .blob2 {
          position: absolute;
          width: 400px; height: 400px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(135,206,235,.07) 0%, transparent 70%);
          bottom: -100px; right: -100px;
          pointer-events: none;
        }

        /* Left panel — decorative */
        .login-left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 60px;
          position: relative;
          z-index: 1;
        }

        @media (max-width: 768px) { .login-left { display: none; } }
        @media (max-height: 560px) { .login-left { justify-content: flex-start; padding: 32px 40px; } }

        .login-left-tagline {
          font-size: 13px;
          font-weight: 500;
          color: #50CCE4;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          margin-bottom: 24px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .login-left-tagline::before {
          content: '';
          width: 32px; height: 2px;
          background: linear-gradient(90deg, #50CCE4, #96E6F0);
          border-radius: 2px;
        }

        .login-left-headline {
          font-size: 48px;
          font-weight: 800;
          color: #fff;
          line-height: 1.1;
          letter-spacing: -1.5px;
          margin-bottom: 20px;
        }
        .login-left-headline span {
          background: linear-gradient(135deg, #50CCE4, #96E6F0);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .login-left-sub {
          font-size: 15px;
          color: #9db4d0;
          line-height: 1.7;
          max-width: 380px;
          margin-bottom: 48px;
        }

        .login-stats {
          display: flex;
          gap: 32px;
        }
        .login-stat {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .login-stat-num {
          font-size: 28px;
          font-weight: 800;
          color: #fff;
          letter-spacing: -1px;
        }
        .login-stat-label {
          font-size: 11px;
          font-weight: 500;
          color: #9db4d0;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        .login-stat-divider {
          width: 1px;
          background: #244b78;
          align-self: stretch;
        }

        /* Right panel — form */
        .login-right {
          width: 440px;
          flex-shrink: 0;
          background: #0B2849;
          border-left: 1px solid #244b78;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 48px 44px;
          position: relative;
          z-index: 1;
        }

        @media (max-width: 768px) {
          .login-right { width: 100%; border-left: none; padding: 36px 24px; }
        }
        @media (max-width: 380px) {
          .login-right { padding: 28px 16px; }
        }
        /* Movil tumbado: el panel deja de centrar verticalmente y se desplaza */
        @media (max-height: 560px) {
          .login-right { justify-content: flex-start; padding-top: 28px; padding-bottom: 28px; }
          .login-logo { margin-bottom: 22px; }
        }
        /* Tablet en vertical: el panel decorativo cabe, pero no a 440px fijos */
        @media (min-width: 769px) and (max-width: 1024px) {
          .login-right { width: 380px; padding: 40px 32px; }
          .login-left { padding: 40px; }
          .login-left-headline { font-size: 36px; }
          .login-stats { gap: 20px; }
        }

        /* Logo */
        .login-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 40px;
        }

        .login-form-title {
          font-size: 22px;
          font-weight: 700;
          color: #fff;
          letter-spacing: -.5px;
          margin-bottom: 6px;
        }
        .login-form-subtitle {
          font-size: 13px;
          color: #9ecadb;
          margin-bottom: 32px;
        }

        .login-field {
          margin-bottom: 18px;
        }
        .login-label {
          display: block;
          font-size: 10.5px;
          font-weight: 600;
          color: #9ecadb;
          letter-spacing: 1.2px;
          text-transform: uppercase;
          margin-bottom: 7px;
        }
        .login-input {
          width: 100%;
          padding: 11px 14px;
          background: #10315a;
          border: 1px solid #6b8cb3;
          border-radius: 10px;
          font-size: 13px;
          font-family: 'DM Sans', system-ui, sans-serif;
          color: #e2eef5;
          outline: none;
          transition: border-color .2s, box-shadow .2s;
        }
        .login-input::placeholder { color: #9db4d0; }
        .login-input:focus {
          outline: 2px solid #96E6F0;
          outline-offset: 2px;
          border-color: #50CCE4;
          box-shadow: 0 0 0 3px rgba(0,180,216,.12);
        }

        .login-error {
          background: rgba(239,68,68,.08);
          border: 1px solid rgba(239,68,68,.25);
          border-radius: 9px;
          padding: 10px 13px;
          font-size: 12px;
          color: #f87171;
          margin-bottom: 18px;
        }

        .login-btn {
          width: 100%;
          padding: 12px;
          background: #50CCE4;
          color: #0B2849;
          border: none;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 700;
          font-family: 'DM Sans', system-ui, sans-serif;
          cursor: pointer;
          letter-spacing: -.2px;
          transition: opacity .15s, transform .1s, box-shadow .2s;
          box-shadow: 0 4px 20px rgba(0,180,216,.25);
        }
        .login-btn:hover:not(:disabled) {
          opacity: .92;
          transform: translateY(-1px);
          box-shadow: 0 6px 24px rgba(0,180,216,.35);
        }
        .login-btn:active:not(:disabled) { transform: translateY(0); }
        .login-btn:focus-visible { outline: 2px solid #96E6F0; outline-offset: 3px; }
        .login-btn:disabled { opacity: .5; cursor: not-allowed; }

        .login-footer {
          margin-top: 32px;
          padding-top: 24px;
          border-top: 1px solid #244b78;
          font-size: 11px;
          color: #9db4d0;
          text-align: center;
          line-height: 1.6;
        }

        /* Fade-in animation */
        .login-card {
          opacity: 0;
          transform: translateY(16px);
          transition: opacity .5s ease, transform .5s ease;
        }
        .login-card.mounted {
          opacity: 1;
          transform: translateY(0);
        }
        .login-left-content {
          opacity: 0;
          transform: translateX(-20px);
          transition: opacity .6s ease .1s, transform .6s ease .1s;
        }
        .login-left-content.mounted {
          opacity: 1;
          transform: translateX(0);
        }
      `}</style>

      <div className="login-root">
        <div className="blob1"/>
        <div className="blob2"/>

        {/* Left decorative panel */}
        <div className="login-left">
          <div className={`login-left-content ${mounted ? "mounted" : ""}`}>
            <div className="login-left-tagline">Gestión de proyectos</div>
            <h1 className="login-left-headline">
              Organiza tu<br/>equipo con<br/><span>claridad total</span>
            </h1>
            <p className="login-left-sub">
              Centraliza proyectos, tareas y equipos en una sola plataforma diseñada para la productividad real.
            </p>
            <div className="login-stats">
              <div className="login-stat">
                <div className="login-stat-num">100%</div>
                <div className="login-stat-label">Tus datos</div>
              </div>
              <div className="login-stat-divider"/>
              <div className="login-stat">
                <div className="login-stat-num">∞</div>
                <div className="login-stat-label">Proyectos</div>
              </div>
              <div className="login-stat-divider"/>
              <div className="login-stat">
                <div className="login-stat-num">24/7</div>
                <div className="login-stat-label">Disponible</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right form panel */}
        <div className="login-right">
          <div className={`login-card ${mounted ? "mounted" : ""}`}>

            {/* Logo */}
            <div className="login-logo">
              <img src={`${process.env.PUBLIC_URL}/brand/logo-horizontal-dark.svg`} alt="Ángel Linares — Manager"
                style={{display:"block",height:44,width:"auto",maxWidth:"100%"}}/>
            </div>

            <div className="login-form-title">Bienvenido</div>
            <div className="login-form-subtitle">Introduce tus credenciales para acceder</div>

            <div className="login-field">
              <Campo><label className="login-label">Email</label>
              <input
                className="login-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleSubmit()}
                placeholder="usuario@angellinares.com"
                autoFocus
              /></Campo>
            </div>

            <div className="login-field">
              <Campo><label className="login-label">Contraseña</label>
              <input
                className="login-input"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleSubmit()}
                placeholder="••••••••"
              /></Campo>
            </div>

            {error && <div className="login-error">{error}</div>}

            <button
              className="login-btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Iniciando sesión…" : "Entrar →"}
            </button>

            <div className="login-footer">
              © {new Date().getFullYear()} Ángel Linares Montalbán<br/>
              Desarrollado por el Dpto. TIC
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
